import React            from 'react';
import EggBox           from '../../../components/EggBox';
import BigProgressBar   from '../../../components/progress_bar/Big';
import SmallProgressBar from '../../../components/progress_bar/Small';
import NextLevelButton  from '../NextLevelButton';
import tests            from './tests';
import colors           from '../../../utils/colors';
import { makeStyles }   from '@material-ui/core/styles';

const newArr = [1,2,3,4,5,6,7,8,9,10];

const seccessMessage  = `כל הכבוד!`
const tryAgainMessage = `נסו שנית`
//const timesUpMessage  = `הזמן אזל`
const continue_       = `המשך`
const start           = `התחלה`

const hideChallenge = false;

//const fast = 4000;
//const slow = 6000;

var clsx = require('classnames')

const useStyles = makeStyles(() => ({
    root: {
        minHeight:       '100vh',
        minWidth:        '100vw',
        maxHeight:       '100vh',
        maxWidth:        '100vw',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        flexFlow:        'column'
    },
    grid: {
        width:               '90vw',
        maxWidth:            550,
        display:             'grid',
        gridTemplateColumns: `repeat(2, 1fr)`,
        gap:                 3,
        transition:          'opacity 0.3s'
    },
    text: {
        fontSize:   27,
        transition: 'opacity 0.3s'
    },
    target: {
        fontSize:        30,
        height:          70,
        width:           150,
        borderRadius:    '0.5em',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        border:          '1px solid #DDD',
        marginBottom:    30,
        transition:      'opacity 0.3s'

    },
    titleBox: {
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        cursor:         'pointer',
        marginBottom:   30,
        transition:     'opacity 0.3s',
    },
    unit: {
       display:        'flex',
       alignItems:     'center',
       justifyContent: 'center',
       border:         '1px solid #DDD',
       borderRadius:   '0.5em',
       transition:     'opacity 0.4s, background 0.1s'
    },
    shake: {
        animation:               'shake 0.5s',
        animationIterationCount: '0.5s',
    },
      dont_shake: {
    },
    toggleButton: {
        width:           200,
        height:          50,
        minHeight:       50,
        marginTop:       30,
        backgroundColor: colors.blue,
        color:           '#FFF',
        display:         'flex',
        alignItems:      'center',
        justifyContent:  'center',
        borderRadius:    '1em',
        cursor:          'pointer',
        transition:      'all 0.5s'
    },
    pyrotechnics: {
        position:        'fixed',
        width:           '100vw',
        height:          '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        transition:      'all 1s',
        zIndex:          2
    },
    message: {
       color:      colors.blue,
      //marginTop:  30,
       transition: 'transform 0.4s',
       textAlign:  'center',
       fontSize:   31
    }
}))

type NumbersProps = {
    size:           number[];
    wideScreen:     boolean;
    handleNavigate: (val: string) => void;
    setLevel:       (val: number) => void;
}



const Numbers: React.FC<NumbersProps> = ({ size, wideScreen, handleNavigate, setLevel }) => {

  const classes = useStyles();

  const [firstTest, setFirstTest]               = React.useState(1)

  const [imagesArr, setImagesArr]               = React.useState(newArr)
  const [numbersArr, setNumbersArr]             = React.useState(newArr)
  const [target, setTarget]                     = React.useState(0)
  const [optionArr, setOptionArr]               = React.useState([] as number[])
  const [testIndex, setTestIndex]               = React.useState(0)
  const [shake, setShake]                       = React.useState(false)
  const [challengeType, setChallengeType]       = React.useState('numbers')
  const [failureCounter, setFailureCounter]     = React.useState(0)
  const [opacity, setOpacity]                   = React.useState(1)
  const [success, setSuccess]                   = React.useState(false)

  //const [timesUp, setTimesUp]                   = React.useState(-1)
  //const [expertTime, setExpertTime]             = React.useState(-1)
  const [buttonClicked, setButtonClicked]       = React.useState(false)
  const [prog, setProg]                         = React.useState(0)
  const [showAnswer, setShowAnswer]             = React.useState(false)

  //const [resetTimer, setResetTimer]             = React.useState(false);
  //const [activateTimer, setActivateTimer]       = React.useState(false)
  //const [miliSeconds, setMiliSeconds]           = React.useState(0);
  const [failTest, setFailTest]                 = React.useState(false);
  const [doOnce, setDoOnce]                     = React.useState(false);


  React.useEffect(() => {
    if (!doOnce && !failTest && failureCounter === 2) {
      setDoOnce(true)
      setTimeout(() => {
        setFailTest(true)
      },1000)
    }
  },[failTest, failureCounter, doOnce])


  /* React.useEffect(() => {

    if (resetTimer) {
      setMiliSeconds(0)
      setResetTimer(false)
    }

    let interval = null as any;

    if (activateTimer) {
      interval = setInterval(() => {
        if (miliSeconds < slow) {
          setMiliSeconds(miliSeconds => miliSeconds + 10);
        }
        if (miliSeconds >= fast && expertTime !== testIndex) {
            setExpertTime(testIndex)
        }
        if (miliSeconds === slow && timesUp !== testIndex) {
          setTimesUp(testIndex)
      }
      }, 10);
    } else if (!activateTimer && miliSeconds !== 0) {

      clearInterval(interval);
    }
    return () => clearInterval(interval);

  }, [resetTimer, activateTimer, miliSeconds, expertTime, timesUp, testIndex, setResetTimer]); */




  const createNewTest = React.useCallback((arr: number[]) => {

        const completeAllChallenges = () => {
          setLevel(2);
          return
        }

        if (!imagesArr.length && !numbersArr.length) {
          completeAllChallenges()
          return;
        }

        let newChallengeTyp: string;

        if (!arr.length && challengeType === 'numbers') {
          arr = numbersArr;
          newChallengeTyp = 'numbers';
        }
        else if (!arr.length && challengeType === 'images') {
          arr = imagesArr;
          newChallengeTyp = 'images';
        }
        else {
          newChallengeTyp = challengeType === 'numbers' ? 'images' : 'numbers'
        }


        const rand            = Math.floor(Math.random() * (arr.length));
        const targ            = arr[rand]
        let optionsArray      = tests.length && targ && tests[targ - 1] ? (tests[targ - 1].options.sort( () => .5 - Math.random() ).slice(0,4)) : [1,2,3,4];
        const correct         = Math.round(Math.random() * 3);
        optionsArray[correct] = targ;

        setOpacity(0)
        setTimeout(() => {
            setTestIndex(testIndex + 1)
            setFailureCounter(0)
            setTarget(targ)
            setOptionArr(optionsArray)
            setSuccess(false)
            setChallengeType(newChallengeTyp)
            setButtonClicked(false)
            setShowAnswer(false)
            setOpacity(1)
         //   setResetTimer(true)
         //   setActivateTimer(true)
            setFailTest(false)
            setDoOnce(false)
        },300)

      
  },[challengeType, testIndex, imagesArr, numbersArr, setLevel])



  const handleClick = (val: number) => {

      if (success || failTest/*  || timesUp === testIndex  */) {
        return
      }

      if (val === target) {

        if (!failureCounter/*  && (expertTime !== testIndex) */) {

            const newTargetArr = challengeType === 'numbers' ? numbersArr.slice() : imagesArr.slice();
            const ind          = newTargetArr.indexOf(target);

            newTargetArr.splice(ind, 1)

            if (challengeType === 'numbers') {
              setNumbersArr(newTargetArr)
            }
            else {
              setImagesArr(newTargetArr)
            }
            setProg(prog + 1)

        }

      //  setActivateTimer(false)
        setSuccess(true)
      }
      else {
        setShake(true)
      //  setResetTimer(true)
      //  setActivateTimer(true)
        setTimeout(() => {
            setShake(false)
        },500)
        setFailureCounter(Math.min(2, failureCounter + 1))
      }
  }


/*
  const handleSelection = (val: number) => {
    if (buttonClicked) {
      return
    }
    if (!buttonClicked) {
      setButtonClicked(true)
    } handleClick(val)
  } */

  const handleButtonClick = () => {

    if (firstTest) {
      createNewTest(newArr)
      setFirstTest(0);
      return
    }

    if (buttonClicked || !(success || /* timesUp === testIndex ||  */failTest)) {
      return
    }

    setButtonClicked(true);
    createNewTest(challengeType === 'numbers' ? imagesArr : numbersArr)
    //createNewTest(challengeType === 'numbers' ? numbersArr : imagesArr)

  }

  /*
  //console.log('imagesArr    :   ',imagesArr)
  //console.log('numbersArr   :   ',numbersArr) */

  const handleGoToNextLevel = () => {
    setLevel(2)
  }

  return (
     <div className = { classes.root }>
        {
            size[0] > 900 && size[1] > 680
            &&
           <BigProgressBar
              size   = { size }
              length = { newArr.length * 2 }
              prog   = { prog }
           />
        }
        {
            (size[0] <= 900 || size[1] <= 680)
            &&
           <SmallProgressBar
              length = { newArr.length * 2 }
              prog   = { prog }
           />
        }
        <div
           className = { challengeType === 'images' ? classes.target : classes.titleBox }
           style     = {{
              opacity: firstTest ? 0 : opacity
           }}
        >
            {
               challengeType === 'images'
               &&
               target
            }
            {
               challengeType === 'numbers'
               &&
               <EggBox
                    wideScreen = { wideScreen }
                    value      = { target }
                    imgSize    = { size[1] > 650 ? [250,90] : [150,75] }
               />
            }
        </div>
        <div
           className = { clsx(classes.grid, (shake ? classes.shake : classes.dont_shake)) }
           style     = {{
              height: size[1] > 650 ? 300 : 230,
           }}
        >
            {
                optionArr.map((val, ind) => {
                    return (
                        <div
                           key       = { `numbersTest${ ind }` }
                           className = { classes.unit }
                           onClick   = { () => handleClick(val) }
                           style     = {{
                               backgroundColor: val === target && (success || showAnswer || failTest /* || timesUp === testIndex */) ? colors.green : 'transparent',
                               opacity:         opacity,
                               cursor:          success || failTest/*  || (timesUp === testIndex) */ ? 'default' : 'pointer',
                               transform:       `translate(0px, ${ hideChallenge ? 150 : 0 }vh)`
                           }}
                        >
                            {
                                challengeType === 'images'
                                &&
                                <EggBox
                                   wideScreen = { wideScreen }
                                   value      = { val }
                                   imgSize    = { size[1] > 650 ? [250,90] : [150,75] }
                                />
                            }
                            {
                                challengeType === 'numbers'
                                &&
                                <div className = { classes.text }>
                                    { val }
                                </div>
                            }
                        </div>
                    )
                })
            }
        </div>
        <>
            <div
              dir       = 'rtl'
              className = { classes.toggleButton }
              onClick   = { handleButtonClick }
              style     = {{
                  opacity:   firstTest ? 1         :  success/*  ||  timesUp === testIndex  */|| failTest ? 1 : 0.3,
                  cursor:    firstTest ? 'pointer' :  success/*  ||  timesUp === testIndex  */|| failTest ? 'pointer' : 'default',
                  transform: `translate(0px, ${ hideChallenge /* || success */ ? 150 : 0 }vh)`
              }}
            >
               { firstTest ? start : continue_ }
            </div>
            <div
              dir       = 'rtl'
              className = { classes.message }
              style     = {{
                transform: `translate(0px, ${ success ? 3 : 150 }vh)`,
              }}
            >
              {/* { expertTime === testIndex ? slowMessage : seccessMessage } */}
              { seccessMessage }
            </div>
           {/*  <div
              dir       = 'rtl'
              className = { classes.message }
              style     = {{
                transform:  `translate(0px, ${ !success && timesUp === testIndex ? 0 : 150 }vh)`,
                opacity:    (showPyrotechnics || showOptionMenu || failTest || timesUp !== testIndex) ? 0 : 1
              }}
            >
              { timesUpMessage }
            </div> */}
            <div
              dir       = 'rtl'
              className = { classes.message }
              style     = {{
                transform:  `translate(0px, ${ failureCounter === 1 ? 0 : 150 }vh)`,
                opacity:   /*  (timesUp !== testIndex) && */ !success && failureCounter === 1 ? 1 : 0
              }}
            >
              { tryAgainMessage }
            </div>
        </>
        <NextLevelButton
            level               = { 1 }
            handleGoToNextLevel = { handleGoToNextLevel }
        />
     </div>
  );
}



export default Numbers;
